import React from 'react';
import { string, shape } from 'prop-types';

export default function HomeNewsTile({ item, itemDirection, viewMoreText }) {
    return (
        <a href={item.url} className={`c-base-tile home-news-tile ${itemDirection}`}>
            <div className="tile-content">
                <div className="date">{item.date}</div>
                <div className="tile-title">
                    {item.title}
                </div>
                {item.thumbnail &&
                    <div className="tile-image-wrapper">
                        <div className="tile-image">
                            <img src={item.thumbnail} alt="" />
                        </div>
                    </div>
                }

                <div className="tile-description">
                    {item.excerpt && <p>{item.excerpt}</p>}
                    <div className="view-more">{viewMoreText}</div>
                </div>
            </div>
        </a>
    );
}

HomeNewsTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        thumbnail: string,
        title: string.isRequired,
        subtext: string,
        excerpt: string
    }).isRequired,
    itemDirection: string.isRequired,
    viewMoreText: string.isRequired
    /* eslint-enable react/no-typos */
};
